import React, {useEffect, useState} from 'react';
import {Button, Card, CardBody, Col, Container, Form, Input, Row} from "reactstrap";
import {useHistory} from "react-router-dom";
import infoIcon from "../../assets/img/icons/user/info-icon.png";
import character from "../../assets/img/backgrounds/step1Character.png";

const Step1 = (props) => {
    const history = useHistory();
    const [formData, setFormData] =
        useState({ assessmentName: "", assessmentFor: "", difficulty: "Easy", companyName: "" });
    useEffect(() => {
        if (props.userData.eventData) {
            setFormData(props.userData.eventData);
        }
    }, [])

    const submitForm = (e) => {
        e.preventDefault();

        props.setUserData({
            ...props.userData,
            eventData:
                {
                    ...props.userData.eventData,
                    assessmentName: formData.assessmentName,
                    assessmentFor: formData.assessmentFor,
                    difficulty: formData.difficulty ?? "Easy",
                    companyName: formData.companyName
                }
        });
        history.push("/easy-flow/step2")
    }
    return (
        <div>
            <Form onSubmit={submitForm}>
                <Container className="">
                    <div className="d-flex justify-content-center">
                        <div className="d-none d-lg-block mb--150 ml--10 character">
                            <div className="mb--150 d-flex">
                                <div className="max-z-index">
                                    <img src={character} />
                                </div>
                                <div className="bubble">
                                    <div className="bubble-text position-relative">
                                        <p className="text-break text-center">Hi</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<Container className="">*/}
                        <Card className="mt--75 step1-card br-60">
                            <CardBody>
                                <Container className="p-lg-5">
                                    <Row>
                                        <Col sm={12} xs={12} lg={6} md={6}>
                                            <div>
                                                <div>
                                                    <h5 className="text-muted ml-2">Name your assessments game</h5>
                                                </div>
                                                <div>
                                                    <Input
                                                        value={formData.assessmentName}
                                                        onChange={(e) => {
                                                            setFormData({ ...formData, assessmentName: e.target.value })
                                                        }}
                                                        required
                                                    />
                                                </div>
                                                <div>
                                                    <h5 className="text-muted ml-2 mt-2">Let us know Your Company Name</h5>
                                                </div>
                                                <div>
                                                    <Input
                                                        value={formData.companyName}
                                                        onChange={(e) => {
                                                            setFormData({ ...formData, companyName: e.target.value })
                                                        }}
                                                        required
                                                    />
                                                </div>
                                                <div className="d-flex mt-3">
                                                    <div>
                                                        <img src={infoIcon} role="button" />
                                                    </div>
                                                    <div className="ml-1">
                                                        <p className="details mt-1">Lorem ipsum dolor sit amet
                                                            consectetur.</p>
                                                        <p className="details">
                                                            Pharetra pellentesque mi leo id
                                                            est ornare. Libero nunc gravida at mattis. Facilisi
                                                            consectetur
                                                            et
                                                            ultricies augue scelerisque gravida scelerisque consequat
                                                            pellentesque.
                                                        </p>
                                                        <p className="details">
                                                            Tincidunt nullam auctor iaculis commodo vel lacus urna ut.
                                                            Scelerisque
                                                            duis nunc consectetur cras sed ultricies vestibulum. Nec
                                                            molestie tortor
                                                            placerat tempor.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm={12} xs={12} lg={6} md={6}>
                                            <div>
                                                <div>
                                                    <h5 className="text-muted ml-2">Let us know whom you are hiring</h5>
                                                </div>
                                                <div>
                                                    <Input
                                                        value={formData.assessmentFor}
                                                        onChange={(e) => {
                                                            setFormData({ ...formData, assessmentFor: e.target.value })
                                                        }}
                                                        required
                                                    />
                                                </div>
                                                <div>
                                                    <h5 className="text-muted ml-2 mt-2">Difficulty</h5>
                                                </div>
                                                <div>
                                                    <Input onChange={(e) => {
                                                        setFormData({ ...formData, difficulty: e.target.value })
                                                    }} type="select" name="selectMulti" >
                                                        <option value={'Easy'}>Easy</option>
                                                        <option alue={'Hard'}>Hard</option>
                                                    </Input>
                                                </div>
                                                <div className="d-flex mt-3">
                                                    <div>
                                                        <img src={infoIcon} role="button" />
                                                    </div>
                                                    <div className="ml-1">
                                                        <p className="details mt-1">Lorem ipsum dolor sit amet
                                                            consectetur.</p>
                                                        <p className="details">
                                                            Pharetra pellentesque mi leo id
                                                            est ornare.
                                                        </p>
                                                        <p className="details">
                                                            Tincidunt nullam auctor iaculis commodo vel lacus urna ut.
                                                            Scelerisque
                                                            duis nunc consectetur cras sed ultricies vestibulum. Nec
                                                            molestie tortor
                                                            placerat tempor.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </CardBody>
                        </Card>
                        {/*</Container>*/}
                    </div>
                    <Container>
                        <Row className="mt-4">
                            <Col lg={6} md={1} sm={0} xs={0}></Col>
                            <Col lg={3} md={5} sm={12} xs={12}>
                                <button className="text-dark btn btn-outline-info demoBtn text-nowrap">Request for demo
                                    video
                                </button>
                            </Col>
                            <Col lg={2} md={5} sm={12} xs={12}>
                                <Button className="nextBtn btn startButton" color="" type="submit">
                                    <span className="text-white font-weight-normal">Next</span>
                                </Button>
                            </Col>
                            <Col lg={1} md={1} sm={0} xs={0}></Col>
                        </Row>
                    </Container>
                </Container>
            </Form>
        </div>
    );
};

export default Step1;